
const StatusCodes = {
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    UNAUTHORIZED: 401
}

export default StatusCodes